import { cn } from '@/lib/utils'

interface LiveNowBadgeProps {
  /** Menu recolhido: so o ponto pulsante sobre o icone. */
  compact?: boolean
  className?: string
}

const LABEL = 'Reunião ao vivo agora'

/** R10-12 — selo vermelho pulsante "Ao vivo" ao lado de "Aulas ao vivo" no menu. */
export function LiveNowBadge({ compact = false, className }: LiveNowBadgeProps) {
  const dot = (
    <span className="relative flex h-2 w-2" aria-hidden>
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" />
      <span className="relative inline-flex h-2 w-2 rounded-full bg-white" />
    </span>
  )

  if (compact) {
    return (
      <span role="status" aria-label={LABEL} title={LABEL} className={cn('relative flex h-2.5 w-2.5', className)}>
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-400 opacity-75" aria-hidden />
        <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-red-500" aria-hidden />
      </span>
    )
  }

  return (
    <span role="status" aria-label={LABEL} title={LABEL} className={cn('ml-auto inline-flex', className)}>
      <span className="inline-flex items-center gap-1 rounded-full bg-red-500 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
        {dot}
        Ao vivo
      </span>
    </span>
  )
}
